import { createSlice } from "@reduxjs/toolkit";
// ⚠️ Deep-imports the DESKTOP variant on purpose — hazard 6.
import { supportLogout, userLogout } from "../LoginSlice";
import { sharedInitialState, sharedReducers } from "./shared";

export type { LicenceExpiryState } from "./shared";

export const licenceExpirySlice = createSlice({
  name: 'licenceExpiry',
  initialState: sharedInitialState,
  reducers: {
    ...sharedReducers,
  },
  // Both bodies are empty in the app source — the cases exist but reset nothing.
  extraReducers: (builder) => {
    builder
      .addCase(userLogout, (state) => {

      })
      .addCase(supportLogout, (state) => {

      });
  },
});

export const {
  getLicenceExpiryStatus,
  setLicenceExpiryStatus
} = licenceExpirySlice.actions;
export default licenceExpirySlice.reducer;
